import { useAuth0 } from '@auth0/auth0-react';
import { useMemo, useState } from 'react';
import { ComponentType } from 'react';
import { useCurrentOrgContext } from 'src/contexts/OrgContext';
import { useOrgs } from 'src/hooks/query/orgHooks';
import NavOrgProfileButton from './NavOrgProfileButton';
import OrgSwitcherContent from './OrgSwitcherContent';
import OrgSwitcherModal from './OrgSwitcherModal';
import useOrgSwitcherNavigation from './useOrgSwitcherNavigation';

type NavOrgSwitcherProps = {
  triggerComponent?: ComponentType<{ onClick: () => void }>;
};

export default function NavOrgSwitcher({
  triggerComponent: TriggerComponent,
}: NavOrgSwitcherProps) {
  const { isAuthenticated } = useAuth0();
  const handleSelectOrg = useOrgSwitcherNavigation();

  const { data: userOrgs, refetch: refetchUserOrgs } = useOrgs({
    config: { enabled: isAuthenticated },
  });
  const { orgId } = useCurrentOrgContext();

  const [orgModalOpen, setOrgModalOpen] = useState(false);

  const currentOrg = useMemo(
    () => userOrgs?.find((org) => org.id === orgId) ?? null,
    [userOrgs, orgId]
  );

  return (
    <>
      {TriggerComponent ? (
        <TriggerComponent onClick={() => setOrgModalOpen(true)} />
      ) : (
        <NavOrgProfileButton currentOrg={currentOrg} onClick={() => setOrgModalOpen(true)} />
      )}
      <OrgSwitcherModal open={orgModalOpen} onClose={() => setOrgModalOpen(false)}>
        <OrgSwitcherContent
          orgs={userOrgs || []}
          onSelectOrg={(org, role) => {
            handleSelectOrg(org, role);
            setOrgModalOpen(false);
          }}
          onInviteStatusUpdated={() => refetchUserOrgs()}
          onClose={() => setOrgModalOpen(false)}
        />
      </OrgSwitcherModal>
    </>
  );
}
